export class P2PPurchaseOrder {
  id = ""
  p2pLink = ""
  zohoBooksLink = ""

  constructor(item?: any) {
    if (item) {
      this.id = item?.id || ""
      this.p2pLink = item?.p2p_po_link || ""
      this.zohoBooksLink = item?.zoho_books_link || ""
    }
  }
}

export class P2PGRN {
  id = ""
  p2pLink = ""

  constructor(item?: any) {
    if (item) {
      this.id = item?.id || ""
      this.p2pLink = item?.p2p_grn_link || ""
    }
  }
}

export class P2PInvoice {
  number = ""
  p2pPaymentRequestLink = ""
  pdfLink = ""

  constructor(item?: any) {
    if (item) {
      this.number = item?.number || ""
      this.p2pPaymentRequestLink = item?.p2p_payment_request_link || ""
      this.pdfLink = item?.pdf_link || ""
    }
  }
}

export class P2PDetails {
  utr = ""
  vendorName = ""
  accountingCenter = ""
  project: { id: string; name: string } | null = null
  purchaseOrders: P2PPurchaseOrder[] = []
  grns: P2PGRN[] = []
  invoices: P2PInvoice[] = []
  transaction: string | null = null
  remark: string | null = null

  constructor(data?: any) {
    if (data) {
      this.utr = data?.utr || ""
      this.vendorName = data?.vendor_name || ""
      this.accountingCenter = data?.accounting_center || ""
      this.project = data?.project
        ? {
            id: data.project?.id || "",
            name: data.project?.name || "",
          }
        : null
      this.purchaseOrders = Array.isArray(data?.po)
        ? data.po.map((po: any) => new P2PPurchaseOrder(po))
        : []
      this.grns = Array.isArray(data?.grn)
        ? data.grn.map((grn: any) => new P2PGRN(grn))
        : []
      this.invoices = Array.isArray(data?.invoice)
        ? data.invoice.map((inv: any) => new P2PInvoice(inv))
        : []
      this.transaction = data?.transaction || null
      this.remark = data?.remark || null
    }
  }
}

export class Transaction {
  accountName = ""
  amount = 0
  balance = 0
  customerId = ""
  customerName = ""
  branch = ""
  date = ""
  description = ""
  id = ""
  invoiceId = ""
  invoiceNumber = ""
  invoiceSource = ""
  invoiceURL = ""
  isCategorised = false
  isMarked = false
  isMatched = false
  isReconciled = false
  isReconEnabled = false
  isSynced = false
  payee = ""
  paymentId = ""
  paymentURL = ""
  referenceNo = ""
  settlements = {
    payments: [],
    invoices: [],
    customer: null,
    creditnotes: null,
  }
  type = ""
  valueDate = ""
  zohoTransactionId = ""
  zohoContactUrl = ""
  categories: {
    level1?: Category | null
    level2?: Category | null
    level3?: Category | null
  } | null = null
  p2pDetails: P2PDetails[] | null = null

  constructor(transaction?: any) {
    if (transaction) {
      this.accountName = transaction?.account_name
      this.amount = transaction?.amount
      this.balance = transaction?.balance
      this.branch = transaction?.branch
      this.customerId = transaction?.customer_id
      this.customerName = transaction?.customer_name
      this.date = transaction?.date
      this.description = transaction?.description
      this.id = transaction?.id
      this.invoiceId = transaction?.invoice_id
      this.invoiceNumber = transaction?.invoice_number
      this.invoiceSource = transaction?.invoice_source
      this.invoiceURL = transaction?.invoice_url
      this.isCategorised = transaction?.is_categorised
      this.isMarked = transaction?.is_marked
      this.isMatched = transaction?.is_matched
      this.isReconciled = transaction?.is_reconciled
      this.isReconEnabled = transaction?.is_recon_enabled
      this.isSynced = transaction?.is_synced
      this.payee = transaction?.payee
      this.paymentId = transaction?.payment_id
      this.paymentURL = transaction?.payment_url
      this.referenceNo = transaction?.reference_no
      this.settlements = {
        payments: transaction?.settlements?.payments || [],
        invoices: Array.isArray(transaction?.settlements?.invoices)
          ? transaction?.settlements?.invoices.map(
              (inv: any) => new Invoice(inv),
            )
          : [],
        customer: transaction?.settlements?.customer || null,
        creditnotes: transaction?.settlements?.creditnotes || null,
      }

      this.type = transaction?.type
      this.valueDate = transaction?.value_date
      this.zohoTransactionId = transaction?.zoho_transaction_id
      this.zohoContactUrl = transaction?.zoho_contact_url
      this.categories = transaction?.categories
        ? {
            level1: transaction?.categories?.level_1
              ? new Category(transaction?.categories?.level_1)
              : null,
            level2: transaction?.categories?.level_2
              ? new Category(transaction?.categories?.level_2)
              : null,
            level3: transaction?.categories?.level_3
              ? new Category(transaction?.categories?.level_3)
              : null,
          }
        : null
      this.p2pDetails = transaction?.p2p_details
        ? transaction.p2p_details.map((p2p: any) => new P2PDetails(p2p))
        : null
    }
  }
}

export class Invoice {
  invoiceNumber = ""
  invoiceId = ""
  invoiceURL = ""
  amount = 0
  taxAmountWithheld = 0
  creditnotes: any[] = []

  constructor(inv?: any) {
    if (inv) {
      this.invoiceNumber = inv?.invoice_number
      this.invoiceId = inv?.invoice_id
      this.invoiceURL = inv?.invoice_url
      this.amount = inv?.amount
      this.taxAmountWithheld = inv?.tax_amount_withheld
      this.creditnotes = inv?.creditnotes || []
    }
  }
}

export class Bank {
  id = ""
  accountName = ""
  isDefaultSelected = false
  allowedFileType = ".csv, .xls, .xlsx"

  constructor(bank?: any) {
    if (bank) {
      this.id = bank?.id
      this.accountName = bank?.account_name
      this.isDefaultSelected = bank?.is_default_selection
      this.allowedFileType =
        bank?.allowed_file_type
          ?.replaceAll(" ", "")
          ?.split(",")
          .map((type: string) => `.${type}`)
          .join(", ") || ".csv, .xls, .xlsx"
    }
  }
}
export class ProcessSchedule {
  message = ""
  status = false
  nextRun = ""
  scheduleStatus = ""
  id = ""
  name = ""
  constructor(ProcessSchedule?: any) {
    if (ProcessSchedule) {
      this.message = ProcessSchedule?.message
      this.status = ProcessSchedule?.data?.status
      this.nextRun = ProcessSchedule?.data?.details?.next_run
      this.scheduleStatus = ProcessSchedule?.data?.details?.status
      this.id = ProcessSchedule?.data?.details?.id
      this.name = ProcessSchedule?.data?.details?.name
    }
  }
}

export class Category {
  id = ""
  value = ""
  constructor(Category?: any) {
    if (Category) {
      this.id = Category?.id
      this.value = Category?.value
    }
  }
}

export class SearchList {
  id = ""
  value = ""
  constructor(item?: any) {
    if (item) {
      this.id = item?.id
      this.value = item?.name
    }
  }
}
